import { Form, FormItemProps } from 'antd';

export const BoldLabelFormItem = ({ children, label, ...rest }: FormItemProps) => {
  return (
    <Form.Item label={<b>{label}</b>} {...rest}>
      {children}
    </Form.Item>
  );
};
